import { render, staticRenderFns } from "./rule-configuration.component.vue?vue&type=template&id=70c8c86d&scoped=true&"
import script from "./rule-configuration.component.vue?vue&type=script&lang=ts&"
export * from "./rule-configuration.component.vue?vue&type=script&lang=ts&"
import style0 from "./rule-configuration.component.vue?vue&type=style&index=0&id=70c8c86d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8c86d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDivider,VForm,VIcon,VSelect,VTextField})
